import { render, staticRenderFns } from "./main.cotizacionesProveedor.vue?vue&type=template&id=166786f6"
import script from "./main.cotizacionesProveedor.vue?vue&type=script&lang=js"
export * from "./main.cotizacionesProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports